import {
    CoPresent,
    EmojiEvents,
    Forum,
    Help,
    Lyrics,
    MenuBook,
    ModeEdit,
    ErrorOutline,
    School
} from "@mui/icons-material";

export const CONTENT_TYPE_ICON_MAP = [
    {
        key: "UNKNOWN",
        name: "Unknown",
        icon: <ErrorOutline />
    },
    {
        key: "PRESENTATION",
        name: "Presentation",
        icon: <CoPresent />
    },
    {
        key: "SONG",
        name: "Song",
        icon: <Lyrics />
    },
    {
        key: "BOOK",
        name: "Book",
        icon: <MenuBook />
    },
    {
        key: "RIGHT_LIGHT",
        name: "Right Light",
        icon: <ModeEdit />
    },
    {
        key: "READING",
        name: "Reading",
        icon: <School />
    },
    {
        key: "CAP_ASSESSMENT",
        name: "CAP Assessment",
        icon: <EmojiEvents />
    },
    {
        key: "FREE_CONVERSATION",
        name: "Free Conversation",
        icon: <Forum />
    },
    {
        key: "NONE",
        name: "None",
        icon: <Help />
    },
];
